import { ADD_DEGREE, DELETE_DEGREE, UPDATE_DEGREE, SET_DEGREE } from "../constants";

const initialState = [];

export const degreeReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case SET_DEGREE: {
            state = [...payload];
            return state;
        }
        case ADD_DEGREE: {
            state = [{ ...payload }, ...state];
            return state;
        }
        case UPDATE_DEGREE: {
            let temp = [...state];
            let index = temp.findIndex(degree => degree._id === payload._id);
            if (index > -1) {
                temp[index] = payload;
            }
            return temp;
        }
        case DELETE_DEGREE: {
            let temp = [...state];
            let index = temp.findIndex(degree => degree._id === payload);
            if (index > -1) {
                temp.splice(index, 1);
            }
            return temp;
        }
        default: {
            return state
        }
    }
};